import { useSelector } from 'react-redux';
import { selectors as directSelectors } from 'state/direct-order/quote';
import { selectors as directRecurringSelectors } from 'state/direct-order-recurring/quote';
import { selectors as distributionSelectors } from 'state/mrDistribution/quote';
import { selectors as collectionSelectors } from 'state/mrCollection/quote';
import { selectors as orderSelectors } from 'state/order';
import { constants as orderConstants } from 'utils/order';

const useGetCurrentQuote = () => {
  const orderType = useSelector(orderSelectors.getTypeOfOrder);
  let selectorPremium = directSelectors;
  if (orderType === orderConstants.DIRECT_ORDER_RECURRING) {
    selectorPremium = directRecurringSelectors;
  } else if (orderType === orderConstants.DISTRIBUTION) {
    selectorPremium = distributionSelectors;
  } else if (orderType === orderConstants.COLLECTION) {
    selectorPremium = collectionSelectors;
  }
  const quoteSelector = selectorPremium['getQuote'];
  const quote = useSelector(quoteSelector);

  return quote || {};
};

export default useGetCurrentQuote;
